<script context="module">
  import {External, M} from "../../external";
  import {makeWebsiteRequest} from "../../Common/tools";

  function getActiveLocale() {
    let settings = External.WebsiteSettings && External.WebsiteSettings.getSettings ? (External.WebsiteSettings.getSettings() || {}) : {};
    let defaultLocale = settings.websiteLanguage || (External.Website ? External.Website.websiteLanguage : '') || 'en';
    let locales = Array.isArray(settings.websiteLocales) ? settings.websiteLocales.slice(0) : [];
    if (locales.indexOf(defaultLocale) < 0)
      locales.unshift(defaultLocale);
    let currentLocale = External.Website ? (External.Website.currentEditLocale || External.Website.defaultEditLocale || defaultLocale) : defaultLocale;
    if (locales.indexOf(currentLocale) < 0)
      currentLocale = defaultLocale;
    return currentLocale;
  }

  export async function saveProductCategory(category) {
    if (category.name.trim() === "") {
      External.Tools.showError(M.ERR_EMPTY_NAME);
      return null;
    }

    let result = await makeWebsiteRequest({
      action: "saveProductCategory",
      data: {
        id: category.id,
        url: category.url,
        name: category.name,
        parent: category.parentCategory,
        order: category.order || 1,
        locale: getActiveLocale()
      }
    });

    return result.data;
  }

  export function addNewCategory(parentCategory, order, then) {
    External.UITools.showProductCategoryEditUI(
      {
        id: -1,
        url: "",
        name: "",
        parentCategory: parentCategory ? parentCategory.id : 0,
        order: order
      },
      async (newCategory, closeAction) => {
        newCategory = await saveProductCategory(newCategory);
        if (newCategory) {
          newCategory.childNodes = [];
          closeAction();
          then(newCategory);
        }
      }
    );
  }
</script>

<script>
  import { createEventDispatcher } from "svelte";
  import { debounce } from "../../Common/tools";

  export let category = {};

  const dispatch = createEventDispatcher();

  let toggle = () => {
    category.expanded = !category.expanded;
  };

  let onDelete = () => {
    External.Tools.prompt(M.DEL_CONFIRM, M.DEL_PRODUCT_CATEGORY_MESSAGE, async function () {
      let result = await makeWebsiteRequest({
        action: "deleteProductCategory",
        data: {
          id: category.id
        }
      });

      dispatch("deleted");
    });
  };

  let onSubcategoryDeleted = (idx) => {
    category.childNodes.splice(idx, 1);
    category.childNodes = category.childNodes;
  };

  let addSubcategory = () => {
    let newOrder = category.childNodes.length ? category.childNodes[category.childNodes.length - 1].order + 1 : 1;
    addNewCategory(category, newOrder, (newCategory) => {
      category.childNodes.push(newCategory);
      category.childNodes = category.childNodes;
      category.expanded = true;
    });
  };

  let onEdit = async () => {
    let categoryToChange = Object.assign({}, category);

    External.UITools.showProductCategoryEditUI(categoryToChange, async (updatedCategory, then) => {
      updatedCategory = await saveProductCategory(updatedCategory);
      if (updatedCategory) {
        category.name = updatedCategory.name;
        category.url = updatedCategory.url;
        then();
      }
    });
  };

  let onNameChange = debounce(async () => {
    await saveProductCategory(category);
  }, 500);

  $: hasChildren = category.childNodes && category.childNodes.length;
</script>

<li class:tmdp-tree-expanded={category.expanded} class:tmdp-tree-branch={hasChildren} data-id={category.id}>
  <div class="tmdp-tree-content tmdp-tree-handle">
    {#if hasChildren}
      <a class="expand-submenu" on:click={toggle} />
    {/if}
    <input type="text" bind:value={category.name} on:change={onNameChange} />
    <div class="tree-controls">
      <a data-tooltip="addSubcategory" data-top="true" class="delete delete-icon modify button-tooltip light-gray-icon circle-effect" on:click={addSubcategory}>
        <i class="material-icons-outlined">add</i>
      </a>
      <a data-tooltip="editTxt" data-top="true" class="delete delete-icon modify button-tooltip light-gray-icon circle-effect" on:click={onEdit}>
        <i class="material-icons-outlined">settings</i>
      </a>
      <a data-tooltip="deletee" data-top="true" class="delete delete-icon modify button-tooltip light-gray-icon circle-effect" on:click={onDelete}>
        <i class="material-icons-outlined">delete</i>
      </a>
    </div>
  </div>
  {#if hasChildren && category.expanded}
    <ol>
      {#each category.childNodes as subCategory, idx (subCategory.id)}
        <svelte:self
          category={subCategory}
          on:deleted={() => {
            onSubcategoryDeleted(idx);
          }} />
      {/each}
    </ol>
  {/if}
</li>
